import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function EditCategoryCommission({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Category Commission</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form">
                        <div className="gap_p">
                            {/* CATEGORY DROPDOWN */}
                            <div className="control_group">
                                <label htmlFor="commission-category">Category</label>
                                <Select
                                    fullWidth
                                    displayEmpty
                                    defaultValue=""
                                    inputProps={{ id: "commission-category" }}
                                >
                                    <MenuItem value="" disabled>
                                        Select category
                                    </MenuItem>
                                    <MenuItem value="electronics">
                                        Electronics Category
                                    </MenuItem>
                                    <MenuItem value="fashion">
                                        Fashion Category
                                    </MenuItem>
                                    <MenuItem value="handmade">
                                        Handmade &amp; Artisan
                                    </MenuItem>
                                    <MenuItem value="new_vendor">
                                        New Vendor Rate
                                    </MenuItem>
                                </Select>
                            </div>

                            {/* RATE FIELD */}
                            <div className="control_group">
                                <label htmlFor="commission-rate">Commission Rate (%)</label>
                                <TextField
                                    placeholder="Enter rate"
                                    fullWidth
                                    hiddenLabel
                                    type="number"
                                    inputProps={{ id: "commission-rate" }}
                                />
                            </div>
                        </div>

                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
